import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import PriceInputComponent from '../../../backoffice/offered-service/price/price-input.component'
import { InfoBox } from '../casting-styled.component'

const i18nScoped = new I18nService(require('./backoffice-custom-price-form.component.yml'))

export default function BackofficeCustomPriceFormComponent ({ data: { market, offeredService, overrideRatePriceCents, overrideRateTaxCents }, store }: StoreProps) {
  const isNoVat = React.useMemo(() => offeredService.vat_price_percentage === 0, [offeredService])
  const priceContainer = React.useMemo(() => {
    return {
      round_on_vat_price: offeredService.round_on_vat_price,
      price_cents: overrideRatePriceCents,
      vat_price_cents: overrideRatePriceCents === null ? null : overrideRatePriceCents + overrideRateTaxCents
    }
  }, [offeredService.round_on_vat_price, overrideRatePriceCents, overrideRateTaxCents])

  const computePricesAndEmit = React.useCallback((body: Partial<typeof priceContainer>) => {
    const rounOnVatPrice = body.round_on_vat_price ?? offeredService.round_on_vat_price
    const taxMulCoeff = isNoVat ? 1 : (1 + offeredService.vat_price_percentage  / 100)
    if (rounOnVatPrice) body.price_cents = body.vat_price_cents === null ? null : body.vat_price_cents / taxMulCoeff
    else body.vat_price_cents = body.price_cents === null ? null : body.price_cents * taxMulCoeff

    if (body.price_cents) body.price_cents = Math.round(body.price_cents)
    if (body.vat_price_cents) body.vat_price_cents = Math.round(body.vat_price_cents)

    store.set({
      overrideRatePriceCents: body.price_cents,
      overrideRateTaxCents: body.vat_price_cents === null ? null : body.vat_price_cents - body.price_cents
    })
  }, [isNoVat, offeredService.round_on_vat_price, offeredService.vat_price_percentage, store])

  return <>
    <PriceInputComponent
      currency={ market.currency }
      formName="no-quotation-"
      isNoVat={ offeredService.vat_price_percentage === 0 }
      fieldName="price_cents"
      fieldTranslator={ () => i18nScoped.t(`price_per_${offeredService.rentable_unit_of_work}${offeredService.round_on_vat_price ? '' : '_no_tax'}`) }
      object={ priceContainer }
      onChange={ val => computePricesAndEmit(val) } />

    { /* This component can be mounted directly EventCreateWithCastingComponent, and should only display the input in that case */ }
    { offeredService.casting_custom_price && <InfoBox children={ i18nScoped.t('no_quotation_tooltip') } /> }
  </>
}
